.av-card {
  background-color: var(--av-card-background-color);
  border-radius: var(--av-border-radius-container);
  box-shadow: var(--av-box-shadow-container);
  overflow: hidden;
  border: 1px solid var(--av-card-border-color);
  border-top-color: var(--av-card-border-top-color);
  transition: 0.3s;
  color: var(--av-card-color);

  &.av-card-bottom {
    &.av-card-floating {
      bottom: calc($container-height + 10px);
    }
  }

  &.av-card-top {
    &.av-card-floating {
      top: calc($container-height + 10px);
    }
  }

  &.av-card-right {
    &.av-card-floating {
      right: 0;
    }
    &.av-card-closed {
      transform: translateX(150px);
    }
    &.av-card-open {
      &.av-card-blur {
        z-index: 100010;
        transform: translate(60px, 40px) scale(0.8);
        &:hover {
          transform: translate(70px, 40px) scale(0.8);
        }
      }
    }
  }

  &.av-card-center {
    &.av-card-floating {
      right: 50%;
      transform: translateX(70%);
    }
    &.av-card-closed {
      transform: translateX(150px);
    }
    &.av-card-open {
      &.av-card-blur {
        z-index: 100010;
        &.av-card-bottom {
          transform: translate(-10px, 70px) scale(0.8);
          &.av-card-mobile,
          &.av-card-mobile:hover {
            transform: translate(-10px, 35px) scale(0.8);
          }
          &:hover {
            transform: translate(-15px, 70px) scale(0.85);
          }
        }
        &.av-card-top {
          transform: translate(-10px, -70px) scale(0.8);
          &.av-card-mobile,
          &.av-card-mobile:hover {
            transform: translate(-10px, 35px) scale(0.8);
          }
          &:hover {
            transform: translate(-15px, -80px) scale(0.85);
          }
        }
      }
      &.av-card-floating.av-card-focus {
        transform: translateX(50%) scale(1);
      }
    }
  }

  &.av-card-left {
    &.av-card-floating {
      left: 0;
    }
    &.av-card-closed {
      transform: translateX(-150px);
    }
    &.av-card-open {
      &.av-card-blur {
        z-index: 100010;
        transform: translate(-60px, 40px) scale(0.8);
        &:hover {
          transform: translate(-70px, 40px) scale(0.8);
        }
      }
    }
  }

  &.av-card-floating {
    position: absolute;
    width: 300px;
    z-index: 100010;
  }

  &.av-card-backdrop-blur {
    background: var(--av-card-background-blur-color);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    // &.av-card-dark {
    //   background: transparentize($color: black, $amount: 0.15);
    // }
  }

  &.av-card-closed {
    opacity: 0;
    visibility: hidden;
  }

  &.av-card-open {
    transform: translateX(0);
    opacity: 1;
    visibility: visible;

    &.av-card-focus {
      z-index: 100030;
      transform: translateX(0) scale(1);
    }
  }

  &.av-card-resizing {
    transition: none;
    backdrop-filter: none;
    .av-card-body {
      pointer-events: none;
    }
  }

  // &.av-card-dark {
  //   background: transparentize($color: black, $amount: 0.1);
  //   color: var(--av-font-color-light);
  //   border: 1px solid black;
  //   border-top-color: #333;
  //   input,
  //   textarea {
  //     background-color: transparent;
  //     color: var(--av-font-color-light);
  //   }
  // }

  .av-card-body {
    padding: 16px;
  }
}

.av-card-tools {
  display: flex;
  position: absolute;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 10;

  &.av-card-tools-left {
    right: 0;
  }
  &.av-card-tools-right {
    left: 0;
  }
  &.av-card-tools-top {
    bottom: 0;
  }
  &.av-card-tools-bottom {
    top: 0;
  }
  &.av-card-tools-center {
    right: 0;
  }

  .tool {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: transparent;
    border: 0;
    padding: 2px 0 0 3px;
    margin-top: 2px;
    position: relative;
    &:focus-visible {
      outline-color: var(--av-color-focus-outline);
    }
  }

  .tool-resize {
    cursor: nwse-resize;

    &.tool-top-left {
      transform: rotate(0);
    }
    &.tool-top-right,
    &.tool-top-center {
      transform: rotate(90deg);
    }
    &.tool-bottom-left {
      transform: rotate(-90deg);
    }
    &.tool-bottom-right,
    &.tool-bottom-center {
      transform: rotate(180deg);
    }
  }
}

av-asset {
  width: 100%;
}
